/** Valeurs stockées en BDD (select legacy employees.position). */
export const EMPLOYEE_POSITION_OPTIONS = [
  { value: "Agent", label: "Agent" },
  { value: "Cadre", label: "Cadre" },
  { value: "Haut Cadre", label: "Haut Cadre" },
] as const;

export type EmployeePositionValue = (typeof EMPLOYEE_POSITION_OPTIONS)[number]["value"];

/** Normalise une valeur libre / ancienne vers une option legacy. */
export function normalizeEmployeePosition(raw: string | null | undefined): string {
  const value = (raw ?? "").trim();
  if (!value) return "";
  const exact = EMPLOYEE_POSITION_OPTIONS.find((o) => o.value === value);
  if (exact) return exact.value;
  const lower = value.toLowerCase();
  if (lower === "agent") return "Agent";
  if (lower === "cadre") return "Cadre";
  if (lower === "haut cadre" || lower === "hautcadre") return "Haut Cadre";
  // Anciennes options UI migration (non legacy)
  if (lower === "chef" || lower === "chef d'antenne" || lower === "chef d’antenne") return "Agent";
  return value;
}

export function formatEmployeePosition(value: string | null | undefined): string {
  const normalized = normalizeEmployeePosition(value);
  if (!normalized) return "—";
  const hit = EMPLOYEE_POSITION_OPTIONS.find((o) => o.value === normalized);
  return hit?.label ?? normalized;
}
